import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import BlogLikes from './BlogLikes'
import { useDispatch, useSelector } from 'react-redux'
import { base_url, postHeader } from '../../../Helper/request'
import axios from 'axios'
// import { isBlogLike } from '../../../Reducer/homeReducer'
import moment from 'moment'
const BlogList = (props) => {
    const location= useLocation()
    const catData = {
        catID: props?.catID,
        catSlug: props?.catSlug,
        catName: props?.category_name.trimEnd()
      };
    const handleData=()=>{
        sessionStorage.setItem("blogData",JSON.stringify(catData))
      }
    return (
        <>
            <div className='mainBlogList'>
                <div className='mb-1 wrpImg'>
                    <Link to={props?.slug}> <img className="featuredImage img-fluid" src={props?.img ? props?.img : "https://cdn.jewelryimages.net/static/domains/malakjewelers/images/store-pics/rings.jpg"} alt="" /> </Link>
                </div>
                <div className='catSection mb-2 pt-2 pb-2 w-100 d-flex align-items-center justify-content-between'>
                {
                        !location.pathname.includes("/category/") &&
                        (props?.category_name) && <div>
                            <Link onClick={handleData} to={props?.catSlug}  className='category_slug transition'>{props?.category_name}</Link>
                        </div>
                    }
                    {/* {
                        props?.author && <div className='author'>
                            By Admin
                        </div>
                    } */}
                </div>
                <h3 className='fs21 blogTitle'>
                    <Link className='transition' to={props?.slug}> {props?.title && props?.title}  </Link>
                </h3>
                <div className='fs13'>
                    {/* {props?.publish_date && props?.publish_date} */}
                    {props?.publish_date ? moment(props?.publish_date, "YYYY-MM-DD").format("MMMM DD, YYYY") : ""}
                    {/* <div className='d-flex align-items-center'>
                    <button className='noBtn' onClick={() => props.hndleLike(props.blog_id, props.b_index)}>
                    {!props?.user_liked ?
                        <img src={blogLikeEmpty}/>:
                        <img src={blogLikeSolid} />}
                        </button>
                        
                        <h6 className='pt-2 mt-1'>{props.total_liked}</h6>
                    </div> */}

                </div>
            </div >
            {/* <div className='d-flex align-items-center'>
                <BlogLikes
                    user_liked={props.user_liked}
                    is_liked={props?.isBLike}
                    blog_id={props.blog_id}
                    b_index={props.b_index}
                    hndleLike={props.hndleLike}
                    total_liked={props.total_liked}
                />
                <Link className='transition ml-2' to={props?.slug}>
                    <div className='d-flex align-items-center pt-1 greenSvg'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 512 512"><path d="M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z" /></svg>
                        <p className=' ps-1 mb-0'>{props.total_comment}</p>
                    </div>
                </Link>
            </div> */}
        </>
    )
}

export default BlogList
